<template>
  <div class="page_zxzt_detail">
    <div class="breadbox m">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>专项展厅</el-breadcrumb-item>
        <el-breadcrumb-item>展览详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="zxzt_banner">
      <div class="scholl_intro">
        <h2><img :src="obj.coverPath"  @click="go('school_exhibition',obj.school)" />{{obj.name}}</h2>
        <p>{{obj.synopsis}}</p>
        <div class="banner_foot">
          <span style="cursor:pointer;" @click="go('school_exhibition',obj.school)">
            <i class="icon_school"></i>{{obj.school_name}}
          </span>
          <span>
            <i class="el-icon-picture-outline"></i> {{obj.opus_total||0}}
          </span>
          <span>
            <i class="el-icon-view"></i>{{obj.popularity||0}}
          </span>
        </div>
        <template v-if="obj.pavilion_2020">
          <router-link :to="`/vr_detail?id=${obj.pavilion}`" class="vr_btn" v-if="obj.pavilion.length">展馆VR</router-link>
          <el-tooltip class="item" effect="dark" content="暂无VR" placement="top-end"  v-else>
            <a class="vr_btn">展馆VR</a>
          </el-tooltip>
        </template>
        
      </div>
    </div>
    <div class="tab">
      <div class="m">
        <div class="tab_l">
        
        </div>
        <div class="tab_r">
          <el-select v-model="searchObj.common_category" class="width240" placeholder="分类" @change="search" filterable>
             <el-option
              label="全部"
              value=""
            ></el-option>
            <el-option
              v-for="item in OpusCategory"
              :key="item.id"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-input style="margin-left:20px;" class="width240" placeholder="请输入内容" v-model="searchObj.name" @change="search">
            <i slot="suffix" class="el-input__icon el-icon-search"></i>
          </el-input>
        </div>
      </div>
    </div>
    <div class="page_zxzt_warp m">
      <zhzt :list="list" :id="'opus'" />
      <myPage :layerpageinfo="layerpageinfo" @pageChange="changePage"></myPage>
    </div>
  </div>
</template>

<script>
import zhzt from "@/components/list_item/zhzt/list";
import myPage from "@/components/myPage/myPage";
export default {
  components: {
    zhzt,myPage
  },
  data() {
    return {
      obj:{},//毕业展信息
      list: [],//作品列表
      layerpageinfo: {
        pageSize: 12,
        pageNo: 0,
        total: 0
      },
      searchObj:{
        common_category:''
      },
      OpusCategory:[]
    };
  },
  created(){
    this.getFrontExhibitions();// 获取毕业展
    this.getOpuses(); // 获取作品列表
    this.getDictionaries('OpusCategory','OpusCategory');//分类
  },
  methods:{
    go(name,id){
      this.$router.push({
        name:name,
        query:{
          id:id
        }
      })
    },
     //点击搜索
    search() {
      this.layerpageinfo.pageNo = 0;
      this.getOpuses();
    },
    // 页数切换
    changePage(pageNo) {
      this.layerpageinfo.pageNo = pageNo;
      this.getOpuses();
    },
    // 获取毕业展
    getFrontExhibitions() {
      let params = {
        id: this.$route.query.id,
        status:'IdentityCertifieStatussuccess'
      };
      this.api.getFrontExhibitions(params).then(res => {
        if (res.error.err_code !== 0) return;
        this.obj = res.obj.list[0] || {};
      });
    },
    
    // 获取作品列表
    getOpuses() {
      let params = Object.assign({},this.layerpageinfo,this.searchObj,{exhibition:this.$route.query.id});
      this.api
        .getOpusExhibitions(params)
        .then(res => {
          if (res.error.err_code !== 0) return;
          this.list = res.obj.list || [];
          this.layerpageinfo.total = res.obj.totalSize;
        });
    },
     /** 获取字典数据 */
    getDictionaries(typeCode, key) {
      return new Promise((resolve,reject)=>{
          let params = {
          typeCode: typeCode,
          pageNo: 0,
          pageSize: 999
        };
        this.api.getDictionaries(params).then(res => {
          this[key] = res.obj.list;
          resolve(res);
        });
      })
      
    },
    
  }
};
</script>

<style lang="scss" scoped>
.page_zxzt_detail {
    .breadbox{
        height: 52px;
        display: flex;
        align-items: center;
    }
  .zxzt_banner {
    width: 1200px;
    padding: 20px 30px;
    box-sizing: border-box;
    margin: 0 auto;
    height: 250px;
    background: url("~@/assets/img/newhome/b3.png") no-repeat center;
    background-size: cover;

    .scholl_intro {
      position: relative;
      padding: 5px 15px 0;
      background: url("~@/assets/img/newhome/b5.png") no-repeat;
      background-size: 100% 100%;
      h2 {
        font-size: 30px;
        line-height: 52px;
        font-weight: bold;
        color: #fff;
        display:flex;
        align-items:center;
        img{
          width:40px;
          height:40px;
          border-radius:50%;
          margin-right:10px;
          cursor:pointer;
        }
      }
      p {
        font-size: 14px;
        color: #ffffff;
        line-height: 24px;
        margin-top: 7px;
        height:120px;
        text-align: justify;
      }
      .banner_foot {
        display: flex;
        padding-bottom:12px;
        span {
          margin-right: 16px;
          font-size: 12px;
          color: #fff;
          i {
            margin-right: 6px;
          }
        }
      }
      .vr_btn {
        width: 80px;
        height: 32px;
        background: #ffffff;
        font-size: 14px;
        text-align: center;
        line-height: 32px;
        color: #0057ff;
        position: absolute;
        top: 9px;
        right: 30px;
        z-index: 1;
      }
    }
  }
   .tab {
   
    .m {
       background: #fff;
      display: flex;
      justify-content: space-between;
      height: 80px;
      align-items: center;
      padding:0 20px;
      box-sizing:border-box;
      .tab_l {
        display: flex;
        span {
          font-size: 16px;
          color: #999;
          margin-right: 70px;
          position: relative;
          cursor:pointer;
        }
        span.active {
          color: #333;
        }
        span.active::after {
          content: "";
          position: absolute;
          bottom: -30px;
          width: 29px;
          height: 3px;
          background: #111111;
          left: 0;
          right: 0;
          margin:0 auto;
        }
      }
      .tab_r {
        display: flex;
      }
    }
  }
  .width240{
    width: 240px;
  }
  .page_zxzt_warp {
    padding: 20px 0 40px;
  }
}
</style>